//filter svg add
document.querySelectorAll('.facets__summary-label').forEach(function(el) {
  el.insertAdjacentHTML('afterend', `
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 11V1M1 6H11" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
  `);
});
 // setInterval(function(){
 //   document.querySelectorAll('.add-mattress-save span.mw-accumulated-title').forEach(el => {
 //      const text = el.textContent;
 //      const cleanedText = text.replace(/\s*\(.*?\)\s*/g, ' ').trim(); // Removes bracketed text
 //      el.textContent = cleanedText;
 //    });

 //   if (jQuery('.add-mattress-save .mw-option__value').hasClass('mw-option__value--selected')) {
 //        jQuery('.add-mattress-save').addClass('hide-label');
 //    } else {
 //        jQuery('.add-mattress-save').removeClass('hide-label');
 //    }
 // },300);

 // filter class add
if (document.querySelectorAll(".facets__summary > div").length) {
    document.querySelectorAll(".facets__summary > div").forEach((curr) => {
        curr.classList.add("filter-section");
    });
}

// filter open close 
document.querySelectorAll("details.facets__disclosure-vertical").forEach((detail) => {
  const updateIcon = () => {
    const filterSection = detail.querySelector(".filter-section");
    if (!filterSection) return;

    const allSVGs = filterSection.querySelectorAll("svg");
    const targetSVG = allSVGs[0]; // Change this if your target is different

    if (!targetSVG) return;

    if (detail.hasAttribute("open")) {
      targetSVG.outerHTML = `
        <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1H11" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      `;
    } else {
      targetSVG.outerHTML = `
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 11V1M1 6H11" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      `;
    }
  };

    // Run once on load
  updateIcon();

  // Run again when toggled
  detail.addEventListener("toggle", updateIcon);
});

// facet-filters__sortby svg changes
const svgWrapper = document.querySelector('.facets-vertical-sort .svg-wrapper');
if (svgWrapper) {
  const originalSVG = svgWrapper.querySelector('svg.icon.icon-caret');
  if (originalSVG) {
    svgWrapper.innerHTML = `
      <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.15019 0.849951L5.5252 4.47495C5.44186 4.55828 5.35853 4.61662 5.2752 4.64995C5.19186 4.68328 5.1002 4.69995 5.0002 4.69995C4.9002 4.69995 4.80853 4.68328 4.7252 4.64995C4.64186 4.61662 4.55853 4.55828 4.4752 4.47495L0.850195 0.849952C0.800195 0.799952 0.762862 0.745618 0.738195 0.686952C0.713529 0.628285 0.700862 0.565951 0.700195 0.499951C0.700195 0.366618 0.746195 0.249951 0.838195 0.149951C0.930195 0.0499511 1.05086 -4.86527e-05 1.2002 -4.86592e-05L8.8002 -4.89915e-05C8.9502 -4.8998e-05 9.0712 0.0499507 9.1632 0.149951C9.2552 0.249951 9.30086 0.366618 9.30019 0.499951C9.30019 0.533284 9.2502 0.649952 9.15019 0.849951Z" fill="#A6946B"/>
      </svg>
    `;
  }
}
// facet-filters__sortby svg changes JS End

// Brand logo Home Page
$(document).ready(function () {
  var $brandslider = $('.brands');

  function brandSlider() {
    if (window.innerWidth <= 1330) {
      if (!$brandslider.hasClass('slick-initialized')) {
        $brandslider.slick({
          dots: false,
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 3000,
          responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
              }
            }
          ]
        });
      }
    } else {
      if ($brandslider.hasClass('slick-initialized')) {
        $brandslider.slick('unslick');
      }
    }
  }

  brandSlider();

  var $featureslider = $('#feature-slider');

  function featureSlider() {
    if (window.innerWidth <= 1199) {
      if (!$featureslider.hasClass('slick-initialized')) {
        $featureslider.slick({
          dots: false,
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 3000,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
              }
            }
          ]
        });
      }
    } else {
      if ($featureslider.hasClass('slick-initialized')) {
        $featureslider.slick('unslick');
      }
    }
  }

  featureSlider();

  let resizeTimer;
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      brandSlider();
      featureSlider();
    }, 200); 
  });
});

// Review Section
document.addEventListener('DOMContentLoaded', function () {
  const target = document.querySelector('.jdgm-carousel-title-and-link');

  if (target) {
    const arrowsHTML = `
      <div class="custom-arrows">
        <a href="javascript:void(0)" id="reel-custom-prev" aria-label="Previous" class="cursor-pointer">
          <svg width="91" height="12" viewBox="0 0 91 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="currentColor" d="M0.469673 5.46968C0.176773 5.76257 0.176773 6.23744 0.469673 6.53034L5.24264 11.3033C5.53554 11.5962 6.01041 11.5962 6.3033 11.3033C6.59619 11.0104 6.59619 10.5355 6.3033 10.2426L2.06066 6.00001L6.3033 1.75737C6.59619 1.46447 6.59619 0.9896 6.3033 0.696707C6.01041 0.403813 5.53554 0.403813 5.24264 0.696707L0.469673 5.46968ZM91 5.25L1 5.25001L1 6.75001L91 6.75L91 5.25Z"/>
          </svg>
        </a>
        <a href="javascript:void(0)" id="reel-custom-next" aria-label="Next" class="cursor-pointer">
          <svg width="91" height="12" viewBox="0 0 91 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="currentColor" d="M90.5303 6.53034C90.8232 6.23744 90.8232 5.76257 90.5303 5.46968L85.7574 0.696707C85.4645 0.403813 84.9896 0.403813 84.6967 0.696707C84.4038 0.9896 84.4038 1.46447 84.6967 1.75737L88.9393 6.00001L84.6967 10.2426C84.4038 10.5355 84.4038 11.0104 84.6967 11.3033C84.9896 11.5962 85.4645 11.5962 85.7574 11.3033L90.5303 6.53034ZM-6.55671e-08 6.75L90 6.75001L90 5.25001L6.55671e-08 5.25L-6.55671e-08 6.75Z"/>
          </svg>
        </a>
      </div>
    `;

    target.insertAdjacentHTML('beforeend', arrowsHTML);

    const customPrev = document.querySelector('.jdgm-carousel-wrapper .custom-arrows #reel-custom-prev');
    const customNext = document.querySelector('.jdgm-carousel-wrapper .custom-arrows #reel-custom-next');

    customPrev.addEventListener('click', function () {
      document.querySelector('.jdgm-carousel__arrows .jdgm-carousel__left-arrow')?.click();
      customPrev.classList.add('active');
      customNext.classList.remove('active');
    });

    customNext.addEventListener('click', function () {
      document.querySelector('.jdgm-carousel__arrows .jdgm-carousel__right-arrow')?.click();
      customNext.classList.add('active');
      customPrev.classList.remove('active');
    });

    // Hide arrows on mobile ≤ 767px
    function toggleArrows() {
      if (window.innerWidth <= 767) {
        document.querySelector('.custom-arrows').style.display = 'none';
      } else {
        document.querySelector('.custom-arrows').style.display = 'flex';
      }
    }
    toggleArrows();
    window.addEventListener('resize', toggleArrows);

    // Autoplay & infinite loop
    // const carouselInterval = setInterval(() => {
    //  document.querySelector('.jdgm-carousel__arrows .jdgm-carousel__right-arrow')?.click();
    // }, 3000); // change 3000ms for faster/slower autoplay

    // Optional: reset interval on manual click to keep smooth autoplay
    // [customPrev, customNext].forEach(btn => {
    //   btn.addEventListener('click', () => {
    //     clearInterval(carouselInterval);
    //     setTimeout(() => {
    //       setInterval(() => {
    //         document.querySelector('.jdgm-carousel__arrows .jdgm-carousel__right-arrow')?.click();
    //       }, 3000);
    //     }, 1000);
    //   });
    // });
  }
});



// product js
var productInterval = setInterval(() => {
    if (document.querySelector('.mw-collapsible--header span.mw-text.mw-accumulated-title') != null) {
        clearInterval(productInterval);
        var titleElements = document.querySelectorAll('.mw-collapsible--header span.mw-text.mw-accumulated-title');
        titleElements.forEach(function(titleElement) {
            if (titleElement.textContent.trim() === '') {
                titleElement.style.display = 'none';
            } else {
              titleElement.style.display = 'inline-block';
            }
        });
    }
 });

// Add Cart btn js

 var formheadingInterval = setInterval(() => {
    if (document.querySelector('.product-form__buttons button.product-form__submit.mw-apo-add-to-cart-cloned') != null) {
        clearInterval(formheadingInterval);
        const searchInput = document.querySelector('.product-form__buttons button.product-form__submit.mw-apo-add-to-cart-cloned');
        const headerWrapper = document.querySelector('.product-item');
        if (searchInput && headerWrapper) {
          headerWrapper.appendChild(searchInput);
        }
    }
 });

var wishlistInterval = setInterval(() => {
    if (document.querySelector('.swym-atw-btn-wrapper.add_to_cart_button_right-position') != null) {
        clearInterval(wishlistInterval);
        const wishlistitem = document.querySelector('.swym-atw-btn-wrapper.add_to_cart_button_right-position');
        const headerWrapper1 = document.querySelector('.product-item');
        if (wishlistitem && headerWrapper1) {
          headerWrapper1.appendChild(wishlistitem);
        }
    }
 });


// Policy Page

document.addEventListener("DOMContentLoaded", function () {
    var privacySection = document.querySelector(".privacy-policy-sec");

    if (privacySection) {
        var links = document.querySelectorAll("#privacy-links a");
        var sections = Array.from(links).map(function (link) {
            return document.querySelector(link.getAttribute("href"));
        });

        links[0].classList.add("active");

        window.addEventListener("scroll", function () {
            var fromTop = window.scrollY + 100;
            var currentSection = sections.filter(function (section) {
                return section.offsetTop <= fromTop;
            }).pop();

            if (currentSection) {
                var activeId = "#" + currentSection.id;

                links.forEach(function (link) {
                    link.classList.remove("active");
                });

                var activeLink = Array.from(links).find(function (link) {
                    return link.getAttribute("href") === activeId;
                });

                if (activeLink) {
                    activeLink.classList.add("active");
                }
            }
        });
    }
});

// review sec arrrow 
function initCustomArrows() {
  const title = document.querySelector('.jdgm-carousel-title-and-link');
  const left = document.querySelector('.jdgm-carousel__arrows .jdgm-carousel__left-arrow');
  const right = document.querySelector('.jdgm-carousel__arrows .jdgm-carousel__right-arrow');

  if (!title || !left || !right) return false; // wait until everything exists

  if (document.querySelector('.custom-arrows')) return true; // already added

  // --- Your SVGs ---
  const prevSVG = `<svg width="91" height="12" viewBox="0 0 91 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M0.469673 5.46968C0.176773 5.76257 0.176773 6.23744 0.469673 6.53034L5.24264 11.3033C5.53554 11.5962 6.01041 11.5962 6.3033 11.3033C6.59619 11.0104 6.59619 10.5355 6.3033 10.2426L2.06066 6.00001L6.3033 1.75737C6.59619 1.46447 6.59619 0.9896 6.3033 0.696707C6.01041 0.403813 5.53554 0.403813 5.24264 0.696707L0.469673 5.46968ZM91 5.25L1 5.25001L1 6.75001L91 6.75L91 5.25Z"/></svg>`;
  const nextSVG = `<svg width="91" height="12" viewBox="0 0 91 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M90.5303 6.53034C90.8232 6.23744 90.8232 5.76257 90.5303 5.46968L85.7574 0.696707C85.4645 0.403813 84.9896 0.403813 84.6967 0.696707C84.4038 0.9896 84.4038 1.46447 84.6967 1.75737L88.9393 6.00001L84.6967 10.2426C84.4038 10.5355 84.4038 11.0104 84.6967 11.3033C84.9896 11.5962 85.4645 11.5962 85.7574 11.3033L90.5303 6.53034ZM-6.55671e-08 6.75L90 6.75001L90 5.25001L6.55671e-08 5.25L-6.55671e-08 6.75Z"/></svg>`;

  // build arrows wrapper
  const wrapper = document.createElement('div');
  wrapper.className = 'custom-arrows';
  wrapper.style.display = 'flex';
  wrapper.style.gap = '8px';
  wrapper.style.alignItems = 'center';

  const prevBtn = document.createElement('button');
  prevBtn.className = 'reel-custom-prev';
  prevBtn.innerHTML = prevSVG;
  prevBtn.style.background = 'none';
  prevBtn.style.border = '0';
  prevBtn.style.cursor = 'pointer';

  const nextBtn = document.createElement('button');
  nextBtn.className = 'reel-custom-next';
  nextBtn.innerHTML = nextSVG;
  nextBtn.style.background = 'none';
  nextBtn.style.border = '0';
  nextBtn.style.cursor = 'pointer';

  wrapper.appendChild(prevBtn);
  wrapper.appendChild(nextBtn);
  title.appendChild(wrapper);

  // events
  prevBtn.addEventListener('click', () => {
    left.click();
    resetAutoplay();
  });
  nextBtn.addEventListener('click', () => {
    right.click();
    resetAutoplay();
  });

  // --- AUTOPLAY ---
  let autoplayTimer = null;
  const AUTOPLAY_SPEED = 3000; // 3s

  function startAutoplay() {
    stopAutoplay();
    autoplayTimer = setInterval(() => {
      right.click();
    }, AUTOPLAY_SPEED);
  }

  function stopAutoplay() {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  }

  function resetAutoplay() {
    stopAutoplay();
    startAutoplay();
  }

  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      stopAutoplay();
    } else {
      startAutoplay();
    }
  });

  startAutoplay(); // kick off autoplay

  return true;
}

// keep checking until carousel exists
const interval = setInterval(() => {
  if (initCustomArrows()) {
    clearInterval(interval);
  }
}, 500);



// Price Update
// jQuery(document).ready(function() {
//   var dynamicPriceUpdate = setInterval(function() {
//         if ($('.mw-apo-price-custom .mw-text:last-child').length) {
//           const updatePrice = () => $(".price-pro h4").text($(".mw-apo-price-custom .mw-text:last-child").text());
//           updatePrice();
//           const target = document.querySelector(".mw-apo-price-custom");
//           target && new MutationObserver(updatePrice).observe(target, { childList: true, subtree: true });

          
//           clearInterval(dynamicPriceUpdate);
//         }
//     }, 500);
// });

$('.best-seller-sec .best-seller-part').slick({
  prevArrow: `<div class="arrow arrow-left">
    <svg class="arrow-left" width="91" height="12" viewBox="0 0 91 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.469673 5.46968C0.176773 5.76257 0.176773 6.23744 0.469673 6.53034L5.24264 11.3033C5.53554 11.5962 6.01041 11.5962 6.3033 11.3033C6.59619 11.0104 6.59619 10.5355 6.3033 10.2426L2.06066 6.00001L6.3033 1.75737C6.59619 1.46447 6.59619 0.9896 6.3033 0.696707C6.01041 0.403813 5.53554 0.403813 5.24264 0.696707L0.469673 5.46968ZM91 5.25L1 5.25001L1 6.75001L91 6.75L91 5.25Z"/>
    </svg>
  </div>`,
  nextArrow: `<div class="arrow arrow-right">
    <svg class="arrow-right" width="91" height="12" viewBox="0 0 91 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M90.5303 6.53034C90.8232 6.23744 90.8232 5.76257 90.5303 5.46968L85.7574 0.696707C85.4645 0.403813 84.9896 0.403813 84.6967 0.696707C84.4038 0.9896 84.4038 1.46447 84.6967 1.75737L88.9393 6.00001L84.6967 10.2426C84.4038 10.5355 84.4038 11.0104 84.6967 11.3033C84.9896 11.5962 85.4645 11.5962 85.7574 11.3033L90.5303 6.53034ZM0 6.75L90 6.75001L90 5.25001L0 5.25L0 6.75Z"/>
    </svg>
  </div>`,
    dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        arrow: false,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

 jQuery(document).ready(function($) {
var eleload = setInterval(function(){
  if(document.querySelectorAll('.extra-matters-finally')){
    clearInterval(eleload);

     jQuery('.add-mattress-save .mw-option__container .mw-option__value').each(function() {
        var $titleElement = jQuery(this).find('.mw-stack--pill__title');
        var titleText = $titleElement.text();
        var categoryText = titleText.match(/\((.*?)\)/);
    
        if (categoryText && categoryText[1]) {
            var master_data = categoryText[1].trim().toLowerCase().replace(/\s+/g, '-'); // Convert to class-friendly format
            jQuery(this).addClass(master_data);
    
            // Remove the parentheses and text inside them
            var newText = titleText.replace(/\s*\(.*?\)\s*/, '');
            $titleElement.text(newText);
        }
    });
      jQuery('.mw-option__value.small-single-2ft6').addClass('active-class-popup');
    document.querySelectorAll('.add-mattress-save div.mw-stack--pill__title').forEach(el => {
      const text = el.textContent;
      const cleanedText = text.replace(/\s*\(.*?\)\s*/g, ' ').trim(); // Removes bracketed text
      el.textContent = cleanedText;
    });
    document.querySelectorAll('.extra-matters-finally .mw-stack--pill__title').forEach(el => {
      const text = el.textContent;
      const match = text.match(/^([^(]+)\s*\(([^)]+)\)/); // Split based on bracket
      if (match) {
        const boldText = match[1].trim();
        const spanText = match[2].trim();
    
       el.innerHTML = `<b>${boldText}</b> <span>(${spanText})</span>`;

      }
    });
  }
},100);
});

document.addEventListener('click', function (event) {
  if (event.target.closest('.inner-tab .mw-option__value')) {
    const clickedElement = event.target.closest('.mw-option__value');

    // Remove 'active' from the current inner collapsible
    const currentCollapsible = clickedElement.closest('.inner-tab').querySelector('.mw-collapsible');
    if (currentCollapsible) {
      currentCollapsible.classList.remove('active');
    }

    // Navigate to the next sibling '.inner-tab'
    const currentInnerTab = clickedElement.closest('.inner-tab');
    let nextInnerTab = currentInnerTab.nextElementSibling;

    while (nextInnerTab && !nextInnerTab.classList.contains('inner-tab')) {
      // Check if the element has 'mattress-icon' and add class to body
      nextInnerTab = nextInnerTab.nextElementSibling;
    }

    if (nextInnerTab) {
      const nextCollapsible = nextInnerTab.querySelector('.mw-collapsible');
      if (nextCollapsible) {
        nextCollapsible.classList.add('active');
      }
      setTimeout(function () {
        if (nextInnerTab.classList.contains('mattress-icon')) {
          console.log('123');
        document.body.classList.add('custom-popup-open');
        document.querySelector('.customization_popup').classList.add('is-visible');
      }
      },1000);
    }
  }
});

jQuery(document).on('click','.product-tab-list .mw-option__value',function(){
    if (jQuery(this).hasClass('mw-option__value--selected')) {
          var master_tab = jQuery(this).find('.mw-stack--card__title').text().trim().toLowerCase().replace(/\s+/g, '-');
        jQuery('.inner-tab').removeClass('active-class-tab');
       jQuery('.inner-tab.'+master_tab+'-variant-tab').addClass('active-class-tab');
    }else{
         jQuery('.inner-tab').removeClass('active-class-tab');
    }
})

jQuery(document).on('click', '.size-variant-tab .mw-option__value', function () {
    var master1 = jQuery(this).find('.mw-stack--card__title').text().trim().toLowerCase().replace(/\s+/g, '-');

    jQuery('.storage-variant-tab .mw-option__container .mw-option__value').removeClass('mws-hidden');

    if (master1 === 'small-single-2ft6' || master1 === 'single-3ft') {
        jQuery('.storage-variant-tab .mw-option__container .mw-option__value:nth-child(4)').addClass('mws-hidden');
        jQuery('.storage-variant-tab .mw-option__container .mw-option__value:nth-child(5)').addClass('mws-hidden');
    }
});

jQuery(document).on('click', '.size-variant-tab .mw-option__value', function () {
    if (jQuery(this).hasClass('mw-option__value--selected')) {
        var master = jQuery(this).find('.mw-stack--card__title').text().trim().toLowerCase().replace(/\s+/g, '-');
      jQuery('.main-pop-wrap-tab').hide();
      jQuery('.add-mattress-save .mw-option__value').removeClass('active-class-popup');
       jQuery('.add-mattress-save .mw-option__value.'+master).addClass('active-class-popup');
       jQuery('.main-pop-wrap-tab[data-handle="' + master + '"]').show();
    }else{
      jQuery('.add-mattress-save .mw-option__value').removeClass('active-class-popup');
       jQuery('.main-pop-wrap-tab').hide();
    }
});

var checkClose = setInterval(function() {
    if ($('.mw-option--type-swatchcard.add-mattress-save').length) {
  jQuery('.storage-variant-tab .mw-option__container .mw-option__value:nth-child(4)').addClass('mws-hidden');
  jQuery('.product-tab-list + div').addClass('active-class-tab');
  jQuery('.storage-variant-tab .mw-option__container .mw-option__value:nth-child(5)').addClass('mws-hidden');
        clearInterval(checkClose);
    }

}, 500);
// product detail mobile slider

$(document).ready(function(){
  $('.product-slider-main').slick({
    dots: true,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  });

});

  // info bar
  $(document).ready(function(){
  if($('.info-slider')){
    $('.info-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
}
 });


// instagram section js
const instatarget = document.querySelector('.instagram-header');

if (instatarget) {
  // Add custom arrows
  const arrowsHTML = `
    <div class="custom-arrows">
      <a href="javascript:void(0)" id="insta-custom-prev" aria-label="Previous" class="cursor-pointer">
        <svg width="91" height="12" viewBox="0 0 91 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill="currentColor" d="M0.469673 5.46968C0.176773 5.76257 0.176773 6.23744 0.469673 6.53034L5.24264 11.3033C5.53554 11.5962 6.01041 11.5962 6.3033 11.3033C6.59619 11.0104 6.59619 10.5355 6.3033 10.2426L2.06066 6.00001L6.3033 1.75737C6.59619 1.46447 6.59619 0.9896 6.3033 0.696707C6.01041 0.403813 5.53554 0.403813 5.24264 0.696707L0.469673 5.46968ZM91 5.25L1 5.25001L1 6.75001L91 6.75L91 5.25Z"/>
        </svg>
      </a>
      <a href="javascript:void(0)" id="insta-custom-next" aria-label="Next" class="cursor-pointer">
        <svg width="91" height="12" viewBox="0 0 91 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill="currentColor" d="M90.5303 6.53034C90.8232 6.23744 90.8232 5.76257 90.5303 5.46968L85.7574 0.696707C85.4645 0.403813 84.9896 0.403813 84.6967 0.696707C84.4038 0.9896 84.4038 1.46447 84.6967 1.75737L88.9393 6.00001L84.6967 10.2426C84.4038 10.5355 84.4038 11.0104 84.6967 11.3033C84.9896 11.5962 85.4645 11.5962 85.7574 11.3033L90.5303 6.53034ZM-6.55671e-08 6.75L90 6.75001L90 5.25001L6.55671e-08 5.25L-6.55671e-08 6.75Z"/>
        </svg>
      </a>
    </div>
  `;

  instatarget.insertAdjacentHTML('beforeend', arrowsHTML);

  const instacustomPrev = document.querySelector('#insta-custom-prev');
  const instacustomNext = document.querySelector('#insta-custom-next');

  instacustomPrev.addEventListener('click', function () {
    document.querySelector('.instafeed-new-arrow.instafeed-new-arrow-prev')?.click();
    instacustomPrev.classList.add('active');
    instacustomNext.classList.remove('active');
  });

  instacustomNext.addEventListener('click', function () {
    document.querySelector('.instafeed-new-arrow.instafeed-new-arrow-next')?.click();
    instacustomNext.classList.add('active');
    instacustomPrev.classList.remove('active');
  });

  // ---- Dots for mobile (≤767px) ----
  function addDotsMobile() {
    const feedItems = document.querySelectorAll('.instafeed-new-arrow'); 
    let dotsContainer = document.querySelector('.insta-dots');

    // Remove old dots if they exist
    if (dotsContainer) dotsContainer.remove();

    if (window.innerWidth <= 767 && feedItems.length > 1) {
      dotsContainer = document.createElement('div');
      dotsContainer.className = 'insta-dots';

      const instaSection = document.querySelector('#insta-feed');
      if (instaSection) {
        instaSection.insertAdjacentElement('afterend', dotsContainer);
      }

      feedItems.forEach((_, index) => {
        const dot = document.createElement('span');
        dot.className = index === 0 ? 'dot active' : 'dot';
        dot.addEventListener('click', () => {
          feedItems[index].click();
          document.querySelectorAll('.insta-dots .dot').forEach(d => d.classList.remove('active'));
          dot.classList.add('active');
        });
        dotsContainer.appendChild(dot);
      });
    }
  }

  // ✅ Wait for arrows to exist before running
  function initDotsWhenReady() {
    if (document.querySelectorAll('.instafeed-new-arrow').length > 1) {
      addDotsMobile();
    } else {
      setTimeout(initDotsWhenReady, 300); // retry until arrows appear
    }
  }

  // Run on load
  initDotsWhenReady();

  // Run on resize
  window.addEventListener('resize', addDotsMobile);
}
$( "a#insta-custom-next" ).on( "click", function() {
  $( "button.instafeed-new-arrow" ).trigger( "click" );
} );



